import { words, getInitialConfigureState } from './globalState';
import {
  certificationWithKey,
  setSignatureByAddressMain,
  getAddressFromKeyNW,
} from './keysAndSigning';
import { getBalancesMonaparty, getAssetInfo, getMonacard, getAddressInfo, getOwnedAssets } from './blockchain';
import { syncHttpRequest2, devLog } from './utils';

// 「ログイン」ボタン押下 HANDLE CLICK LOGIN
async function handleClickLogin({
  dispatch,
  popupLayer,
  keyPairs,
  keyPairsInPoolAll = {},
  sessionToOverride = {},
  activeAddressCandidate = null,
  login,
  walletType,
  session,
  marginOfSessionTime,
  assetInfos,
  monacards,
  network,
  clientParameters,
  language,
}) {
  let request = {};
  let messages = {};
  let certifications = [];
  const popupLayerNext = (popupLayer !== undefined && popupLayer !== null) ? (popupLayer + 1) : 0;
  const now = Date.now();

  // state固定
  const stateFixed = {
    // signatureVersion: state.config.clientParameters.signatureVersion.login,
    signatureVersion: '1',
    // addressCheck: state.addressCheck,
    walletType: walletType,
    addressCheck: 'off',
  };

  devLog('session', JSON.stringify(session));
  devLog('session keys', JSON.stringify(Object.keys(session)));

  // セッション固定

  for (const address of Object.keys(session)) {
    stateFixed[address] = {
      sessionId: session[address].sessionId,
      expirationOfSession: session[address].expirationOfSession,
    };
  }

  // セッションのオーバーライド

  const addressesOverridden = Object.keys(session);

  for (const address of Object.keys(sessionToOverride)) {
    if (stateFixed[address] === undefined) {
      stateFixed[address] = {};
      addressesOverridden.push(address);
    }

    stateFixed[address].sessionId = sessionToOverride[address].sessionId;
    stateFixed[address].expirationOfSession = sessionToOverride[address].expirationOfSession;
  }

  // 有効なセッションに絞り込む。

  for (const address of addressesOverridden) {
    if (stateFixed[address].expirationOfSession >= now + (marginOfSessionTime ?? 60000)) {
      certifications.push({
        address: address,
        sessionId: stateFixed[address].sessionId,
      });
    }
  }

  if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'login', stateFixed, certifications, clientTime: now, extendedCertificationProperties: null, signingMode: 'allKeys', network, language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties: null, messageType: 'login', language });
  }

  // 対象がなかったり、addressMainが指定されているにも関わらずcertificationsに含まれていなかった場合は戻る。ただし、KeyPairsが渡されていない場合は、鍵を要求する。

  if ( certifications.length === 0) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    throw new Error(JSON.stringify({ error: 'noCertificationOrNoCertificationForAddressMain', notification: 'failedToLogin' }));
  }

  request.body = JSON.stringify({
    "body": {
      "certifications": certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MS_API_DOMAIN + '/login';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'user', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  const body = response.body;
  const addresses = Object.keys(body ?? {});
  let loginAddressCount = {};

  if ( response.status === 'fulfilled' && body !== undefined && body !== null) {
    loginAddressCount.signature = addresses
    .filter( address => body[address].certificatedBy === 'signature' )
    .length;

    loginAddressCount.sessionId = addresses
    .filter( address => body[address].certificatedBy === 'sessionId' )
    .length;

    loginAddressCount.none = addresses
    .filter( address => body[address].certificatedBy === 'none' )
    .length;

    loginAddressCount.success = loginAddressCount.signature + loginAddressCount.sessionId;
    loginAddressCount.failure = loginAddressCount.none;
    loginAddressCount.total = loginAddressCount.success + loginAddressCount.failure;
  }
  else {
    loginAddressCount = {
      signature: null,
      sessionId: null,
      none: null,
      success: null,
      failure: null,
      total: null,
    };
  }

  // let certification;

  if ( response.status === 'fulfilled' ) {

    for (const address of addresses) {

      // 署名した場合もろもろ更新
      if (body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': body[address]['sessionId'], 'expirationOfSession': body[address]['expirationOfSession']} });

        // certification設定
        // certification = { addressMain: address, sessionId: response.body[address]['sessionId'] };
      }
      else if (body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }

      // MONA残高・カード関連情報取得
      if (body[address]['certificatedBy'] === 'signature' || body[address]['certificatedBy'] === 'sessionId') {

        // 保有アセット取得
        getBalancesMonaparty({ dispatch, address, clientParameters })
        .then( (result) => {
          let assets;

          if (result.status === 'fulfilled') {
            const balance = result.body;
            assets = Object.keys(balance);
          }
          else {
            throw new Error(result.error);
          }

          // アセット情報取得
          return getAssetInfo({ dispatch, assets, assetInfos, clientParameters });
        })
        .then( (result) => {
          let assetInfo;

          if (result.status === 'fulfilled') {
            assetInfo = result.body;
          }
          else {
            throw new Error(result.error);
          }

          // モナカード情報取得
          const assetCommons = Object.keys(assetInfo)
          .filter( asset => {
            try {
              return JSON.parse(assetInfo[asset]?.description).monacard === undefined;
            }
            catch (error) {
              return true;
            }
          })
          .map( asset => assetInfo[asset].asset_longname === null ? asset : assetInfo[asset].asset_longname );

          getMonacard({ dispatch, assets: assetCommons, monacards });
        })
        .catch( (error) => {
          // stateFixed.addressMainだったら、エラー＆再ログインしてください通知。
        });

        // MONA残高取得

        getAddressInfo({ clientParameters, address })
        .then( (result) => {
          if (result.status === 'fulfilled') {
            const balance = result.body.balance;
            dispatch({ type: 'setStateMultiLayers', keys: ['balance', 'mona', address], value: balance });
          }
          else {
            devLog('failed to get address info.');
            // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[language] + '3.5' });
          }
        });

        // オウンドアセット情報取得
        getOwnedAssets({ dispatch, address, clientParameters })
        .then( (result) => {
          if (result.status === 'fulfilled') {
          }
          else {
            devLog('failed to get owned asset.');
            // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[language] + '3.5' });
          }
        });

        // let activeCertification;

        // if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
        //   if  (response.body[stateFixed.addressMain].certificatedBy === 'signature') {
        //     activeCertification = {
        //       address: stateFixed.addressMain,
        //       sessionId: response.body[stateFixed.addressMain].sessionId,
        //       expirationOfSession: response.body[stateFixed.addressMain].expirationOfSession,
        //     };
        //   }
        // }

        // const result = await handleClickGetPointSum(state, dispatch, activeCertification);
        // devLog('point sum', JSON.stringify(result.body));
      }
    }

    // ユーザー未登録、規約未同意の場合は、対象アドレスリストをポップアップで表示する。

    const addressesThatRequireUserRegistration = addresses.filter( address => body[address].applicationMessage === 'not accept TAC yet.');
    const addressesThatRequireAgreementOfTAC = addresses.filter( address => body[address].applicationMessage === 'you must accept the terms and conditions of the current version.');

    const basicInformationThatRequiresAgreementOfTAC = {};
    const applicationMessageParameterThatRequiresAgreementOfTAC = {};
    for (const address of addressesThatRequireAgreementOfTAC) {
      basicInformationThatRequiresAgreementOfTAC[address] = body[address].basicInformation;
      applicationMessageParameterThatRequiresAgreementOfTAC[address] = body[address].applicationMessageParameter;
    }

    if (addressesThatRequireUserRegistration.length > 0 || addressesThatRequireAgreementOfTAC.length > 0) {
      const popup = {
        type: 'registrationAndAgreementListPopup',
        body: {
          addressesThatRequireUserRegistration,
          addressesThatRequireAgreementOfTAC,
          basicInformationThatRequiresAgreementOfTAC,
          applicationMessageParameterThatRequiresAgreementOfTAC,
        },
      };

      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
    }
  }
  else {
    throw new Error(JSON.stringify({ error: 'failedToLogin', notification: 'failedToLogin' }));
  }

  // アクティブアドレスを設定

  let activeAddress;

  if (activeAddressCandidate !== undefined && activeAddressCandidate !== null && activeAddressCandidate !== '') {
    if (
      (body?.[activeAddressCandidate]?.basicInformation !== undefined && body[activeAddressCandidate].basicInformation !== null) &&
      (body?.[activeAddressCandidate]?.certificatedBy === 'signature' || body?.[activeAddressCandidate]?.certificatedBy === 'sessionId')
    ) {
      activeAddress = activeAddressCandidate;
    }
    else {
      activeAddress = null;
    }
  }
  else if (keyPairs !== undefined && keyPairs !== null && keyPairs.length >= 1) {
    const activeKeyPair = keyPairs.find( keyPair => {
      const address = getAddressFromKeyNW({ dispatch, keyPair, language, network });
      return (
        (body?.[address]?.basicInformation !== undefined && body[address].basicInformation !== null) &&
        (body?.[address]?.certificatedBy === 'signature' || body?.[address]?.certificatedBy === 'sessionId')
      );
    });

    activeAddress = activeKeyPair ? getAddressFromKeyNW({ dispatch, keyPair: activeKeyPair, language, network }) : null;
  }
  else if (stateFixed.addressMpurse !== undefined && stateFixed.addressMpurse !== null && stateFixed.addressMpurse !== '') {
    if (
      (body?.[stateFixed.addressMpurse]?.basicInformation !== undefined && body[stateFixed.addressMpurse].basicInformation !== null) &&
      (body?.[stateFixed.addressMpurse]?.certificatedBy === 'signature' || body?.[stateFixed.addressMpurse]?.certificatedBy === 'sessionId')
    ) {
      activeAddress = stateFixed.addressMpurse;
    }
    else {
      activeAddress = null;
    }
  }
  else {
    activeAddress = null;
  }

  // 各種stateにアクティブアドレスをセット

  dispatch({ type: 'setStateMultiLayers', keys: ['active', 'addressMain'], value: activeAddress });
  dispatch({ type: 'setStateMultiLayers', keys: ['sendMona', 'addressFrom'], value: activeAddress ?? '' });
  dispatch({ type: 'setStateMultiLayers', keys: ['sendXmp', 'addressFrom'], value: activeAddress ?? '' });
  dispatch({ type: 'setStateMultiLayers', keys: ['sendToken', 'addressFrom'], value: activeAddress ?? '' });
  dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'addressIssuer'], value: activeAddress ?? '' });
  dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'parent'], value: '' });
  dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'addressOwner'], value: activeAddress ?? '' });

  if  (activeAddress !== undefined && activeAddress !== null) {
    // 基本情報をconfigureにセット
    dispatch({ type: 'setState', key: 'configure', value: body[activeAddress].basicInformation });

    // // cookie情報更新(アドレス情報)
    // const userName = state.usersMonacotto[stateFixed.addressMain] !== undefined ? state.usersMonacotto[stateFixed.addressMain].userName : stateFixed.addressMain;
    // const cookiesNew = [
    //       {
    //         action: 'login',
    //         addressType: 'addressMain',
    //         description: `${userName}`,
    //         time: now,
    //         address: stateFixed.addressMain
    //       },
    // ];

    // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);

    // ログインポップアップを消す
    dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
  }
  else {
    dispatch({ type: 'setState', key: 'configure', value: getInitialConfigureState() });
  }

  return { ...response, activeAddress, loginAddressCount };
}

export {
  handleClickLogin,
};